import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dialog from '../../components/dialog'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { Button, TextField, Checkbox, Paper } from '@material-ui/core'
import { RegisterUser } from '../../actions/cognito'
import './styles.css'

const hasNumericChar = /.*[0-9]{1,}.*/
const hasCapitalChar = /.*[A-Z]{1,}.*/
const hasSpecialChar = /.*[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`]{1,}.*/

class Register extends Component {
  constructor (props) {
    super(props)
    this.register = this.register.bind(this)
    this.state = {
      email: '',
      password: '',
      passwordVerify: ''
    }
  }

  render () {
    let passwordFeedback = null
    if (this.state.password.length > 0) {
      // we have a password, let's see if it matches constraints
      if (hasNumericChar.test(this.state.password) === false) {
        passwordFeedback = 'Use at least 1 numeric character.'
      } else if (hasCapitalChar.test(this.state.password) === false) {
        passwordFeedback = 'Use at least 1 capital character.'
      } else if (hasSpecialChar.test(this.state.password) === false) {
        passwordFeedback = (<div>Use at least 1 special character:<br />{'^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' : ; | _ ~ `'}</div>)
      } else if (this.state.password.length < 8) {
        passwordFeedback = 'Use at least 8 characters.'
      }
    }

    return (
      <div className='register-background'>
        <div className='register-box'>
          <Paper elevation={1} className='register'>
            <div className='title'>Register - Mare Nostrum</div>
            <div className='form'>
              <div className='data'>
                <label htmlFor='txtEmail'>Email</label>
                <TextField 
                  type='text'
                  id='txtEmail'
                  value={this.state.email}
                  onChange={event => this.setState({ email: event.target.value })} />
              </div>
              <div className='data'>
                <label htmlFor='txtPassword'>Password (*)</label>
                <TextField
                  type='password'
                  id='txtPassword'
                  value={this.state.password}
                  onChange={event => this.setState({ password: event.target.value })} />
              </div>
              {passwordFeedback && (
                <div className='alert alert-warning' role='alert'>
                  {passwordFeedback}
                </div>
              )}
              <div className='data'>
                <label htmlFor='txtPasswordVerify'>Verify Password</label>
                <TextField
                  type='password'
                  id='txtPasswordVerify'
                  value={this.state.passwordVerify}
                  onChange={event => this.setState({ passwordVerify: event.target.value })} />
              </div>
              <div className='iagree'>
                <div className='checkbox-container'>
                  <Checkbox 
                    id='chkAgreePolicy' 
                    onChange={event => this.setState({ chkAgreePolicy: event.target.checked })} />
                </div>
                <div className='checkbox-text'>
                  I agree to the <a href='https://www.runthemarenostrum.com/rules.html' target='_blank' rel='noopener noreferrer'>rules of engagement</a>  <br/>
                  and our <a href='https://www.runthemarenostrum.com/privacy-policy.html' target='_blank' rel='noopener noreferrer'>privacy policy</a>.
                </div>
              </div>
              <div className='actions'>
                <Button variant='contained' color='primary' onClick={this.register} disabled={ this.state.chkAgreePolicy !== true }>Signup</Button>
              </div>
              {this.state.warning && (
                <div className='alert alert-danger' role='alert'>
                  {this.state.warning}
                </div>
              )}
              <div className='info'>
                (*) Your password should contain at least 8 characters. 
                It should have at least one capital, one number and one special character.
                Once registered you will receive an email verification email. 
              </div>
              <div className='go-back'>
                <Link to='/login'>Go back</Link> and login with existing account.
              </div>
            </div>
            {this.state.showVerificationDialog && (
              <Dialog title='Verification Link' actions={[{title: 'Got it!'}]} onAction={() => this.showVerificationDialogDone() }>
                Great! As a last step before you can start using your account, 
                we will send a verification link to your email address.
                Once you have clicked that link, we will activate your account 
                and you will be able to sign in.
              </Dialog>
            )}
          </Paper>
        </div>
      </div>
    )
  }

  showVerificationDialogDone () {
    this.setState({ showVerificationDialog: false })    
    this.props.history.push('/')
  }

  register () {
    this.setState({ warning: null })
    if (this.state.password !== this.state.passwordVerify) {
      this.setState({ warning: 'Entered value for password and verify password are different.' })
    } else if (this.state.password.length < 8) {
      this.setState({ warning: 'Your password should at least have 8 characters.' })
    } else {
      this.props.registerUser(this.state.email, this.state.password)
        .then((user) => {
          this.setState({ showVerificationDialog: true })
        })
        .catch((reason) => {
          this.setState({ warning: reason.message })
        })
    }
  }
}

const mapDispatch = (dispatch) => {
  return {
    registerUser: (username, password) => RegisterUser(username, password)(dispatch)
  }
}

const mapState = (state) => ({ })

export default connect(mapState, mapDispatch)(withRouter(Register))
